import { CodedLookup, TxtAttach } from './index.model';


export class ParamInfo {
    constructor() { }

    ParamID: number;
    DispValue: string;
    DispOrder: number;
    ProductID?: number;
    ModuleID: number;
    ParamName: string;
    CustomName: string;
    IsUser?: number;
    CodeType: number;
    MJGlobal?: number;
    DefaultValue: any;
    ParamValue: string;
    IsSystem: number;
    ParamType: string;
    IsActive: number;
    InActiveDttmUTC?: Date;
    MaxLength?: number;
    DefState: string;
    IsPassword: number;
    PnxCategory: string;
    CustCategory: string;
    VersionNo: number;
    IsRestrictCloud: number;
    IsCodedLookup: number;
    CreatedDttmUTC: Date;
    ModifiedDttmUTC: Date;
    JurisID?: number;
    CodedLookup: CodedLookup[];
    MultiSelect: string[];
    TxtAttach: TxtAttach;
}


// WEBPACK FOOTER //
// D:/NewPhoenixScrum/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/core/paraminfo.model.ts